import React from 'react'
import PropTypes from 'prop-types'
import colors from '@settings/styleSettings'

const Info = ({ color }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99984 10.1665C7.14428 10.1665 7.26384 10.1194 7.3585 10.0252C7.45273 9.9305 7.49984 9.81095 7.49984 9.6665V6.8165C7.49984 6.68317 7.45273 6.56917 7.3585 6.4745C7.26384 6.38028 7.14428 6.33317 6.99984 6.33317C6.85539 6.33317 6.73606 6.38028 6.64184 6.4745C6.54717 6.56917 6.49984 6.68873 6.49984 6.83317V9.68317C6.49984 9.8165 6.54717 9.9305 6.64184 10.0252C6.73606 10.1194 6.85539 10.1665 6.99984 10.1665ZM6.99984 5.19984C7.15539 5.19984 7.28317 5.14695 7.38317 5.04117C7.48317 4.93584 7.53317 4.80539 7.53317 4.64984C7.53317 4.50539 7.48317 4.38028 7.38317 4.2745C7.28317 4.16917 7.15539 4.1165 6.99984 4.1165C6.84428 4.1165 6.7165 4.16917 6.6165 4.2745C6.5165 4.38028 6.4665 4.50539 6.4665 4.64984C6.4665 4.80539 6.5165 4.93584 6.6165 5.04117C6.7165 5.14695 6.84428 5.19984 6.99984 5.19984ZM6.99984 13.3332C6.12206 13.3332 5.29717 13.1665 4.52517 12.8332C3.75273 12.4998 3.08317 12.0498 2.5165 11.4832C1.94984 10.9165 1.49984 10.2469 1.1665 9.4745C0.833171 8.7025 0.666504 7.87762 0.666504 6.99984C0.666504 6.12206 0.833171 5.29695 1.1665 4.5245C1.49984 3.7525 1.94984 3.08317 2.5165 2.5165C3.08317 1.94984 3.75273 1.49984 4.52517 1.1665C5.29717 0.833171 6.12206 0.666504 6.99984 0.666504C7.87762 0.666504 8.70273 0.833171 9.47517 1.1665C10.2472 1.49984 10.9165 1.94984 11.4832 2.5165C12.0498 3.08317 12.4998 3.7525 12.8332 4.5245C13.1665 5.29695 13.3332 6.12206 13.3332 6.99984C13.3332 7.87762 13.1665 8.7025 12.8332 9.4745C12.4998 10.2469 12.0498 10.9165 11.4832 11.4832C10.9165 12.0498 10.2472 12.4998 9.47517 12.8332C8.70273 13.1665 7.87762 13.3332 6.99984 13.3332ZM6.99984 12.3332C8.47762 12.3332 9.73606 11.8138 10.7752 10.7752C11.8138 9.73606 12.3332 8.47762 12.3332 6.99984C12.3332 5.52206 11.8138 4.26362 10.7752 3.2245C9.73606 2.18584 8.47762 1.6665 6.99984 1.6665C5.52206 1.6665 4.26384 2.18584 3.22517 3.2245C2.18606 4.26362 1.6665 5.52206 1.6665 6.99984C1.6665 8.47762 2.18606 9.73606 3.22517 10.7752C4.26384 11.8138 5.52206 12.3332 6.99984 12.3332Z"
        fill={color}
      />
    </svg>
  )
}

Info.propTypes = {
  color: PropTypes.string,
}

Info.defaultProps = {
  color: colors.strongRed,
}

export default Info
